exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conclusion { \r\n\tdisplay: block;\r\n\theight: 100%;\r\n}\r\n\r\n.conclusion {\r\n\tpadding: 1em;\r\n}\r\n\r\n.conclusion p {\r\n\tpadding-bottom: 1em;\r\n}", ""]);

// exports
